import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRefresh } from 'react-admin';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Snackbar } from '@mui/material';
import { AdminAlert, useAdminEvents } from '../../hooks/useAdminEvents';

/**
 * Alerty z backendu (np. rabat wyczerpal budzet). W przeciwienstwie do useNotify
 * nie znikaja same — zostaja, az uzytkownik je zamknie. Kilka zdarzen naraz
 * pokazujemy po kolei.
 */
export const AdminAlertHost = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const refresh = useRefresh();
  const [queue, setQueue] = useState<AdminAlert[]>([]);

  // Zdarzenie zwykle zmienia dane na ekranie (np. status rabatu na liscie) - odswiezamy widok.
  const enqueue = useCallback(
    (alert: AdminAlert) => {
      setQueue((current) =>
        current.some((a) => a.id === alert.id) ? current : [...current, alert],
      );
      refresh();
    },
    [refresh],
  );

  useAdminEvents(enqueue);

  const current = queue[0];
  const next = () => setQueue((items) => items.slice(1));

  if (!current) {
    return null;
  }

  return (
    <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        severity="warning"
        variant="filled"
        onClose={next}
        action={
          current.link ? (
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                navigate(current.link as string);
                next();
              }}
            >
              {t('adminEvents.show')}
            </Button>
          ) : undefined
        }
      >
        {t(current.messageKey, current.params)}
      </Alert>
    </Snackbar>
  );
};
